import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
import { LivePage } from "./pages/LivePage";
import { SchedulePage } from "./pages/SchedulePage";
import { ClipsPage } from "./pages/ClipsPage";
import { AboutPage } from "./pages/AboutPage";
import { CommunityPage } from "./pages/CommunityPage";
import { ContactPage } from "./pages/ContactPage";
import { OwnerPage } from "./pages/OwnerPage";
import { NotFoundPage } from "./pages/NotFoundPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/live" element={<LivePage />} />
                        <Route path="/schedule" element={<SchedulePage />} />
                        <Route path="/clips" element={<ClipsPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/community" element={<CommunityPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/owner" element={<OwnerPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" />
        </div>
    );
}

export default App;
